import { render } from "./NavTabs.vue?vue&type=template&id=33f0bf14&scoped=true"
import script from "./NavTabs.vue?vue&type=script&lang=js"
export * from "./NavTabs.vue?vue&type=script&lang=js"

import "./NavTabs.vue?vue&type=style&index=0&id=33f0bf14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33f0bf14"

export default script